export const PAYMENT_GATEWAY_OPTIONS = [
  {id: "payping", title: "PayPing"},
  {id: "asanpardakht", title: "آسان پرداخت"},
];

export const DEFAULT_PAYMENT_METHOD = "asanpardakht";

export const getPaymentResponseData = (responseData) => {
  if (typeof responseData === "string") {
    return JSON.parse(responseData);
  }

  return responseData || {};
};

export const redirectToPaymentLink = (responseData) => {
  const {payment_link, redirect_url, should_redirect} = getPaymentResponseData(responseData);
  const redirectUrl = redirect_url || payment_link;

  if (should_redirect === true && redirectUrl) {
    window.location.href = redirectUrl;
  }
};
